export default function PromoBanner() {
  return (
    <div className="bg-primary text-primary-foreground py-3 text-center">
      <p className="text-sm md:text-base font-medium">
        <span className="font-bold">Start Free:</span> No credit card required for the free plan. Upgrade anytime.{" "}
        <a
          href="/pricing"
          className="underline hover:no-underline"
          data-testid="link-view-plans"
        >
          View Plans
        </a>
      </p>
    </div>
  );
}
